import React from "react";
import MuiFormControl from "@mui/material/FormControl";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiRadio from "@mui/material/Radio";
import MuiRadioGroup from "@mui/material/RadioGroup";
import MuiButton from "@mui/material/Button";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerDocumentCreate from "../../controller/custom/DocumentCreate";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewDatepicker from "../../view/Datepicker";

let isRendered = false;

const viewPageDocumentCreate: React.FC = () => {
    // Variable
    const controllerDocumentCreate = new ControllerDocumentCreate(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerDocumentCreate.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerDocumentCreate.getSelectOption && controllerDocumentCreate.getValidationForm) {
        return (
            <div className="view_document_create" data-at_id="view_document_create">
                <form className="form">
                    <div className="left">
                        <div className="content">
                            <p className="section_title">{controllerLocalization.getStorageMain.detail}:</p>
                            <MuiFormControl className="field_container">
                                <MuiTextField
                                    variant="outlined"
                                    className="field_value"
                                    data-at_id="input_client_name"
                                    name="client_name"
                                    label={controllerLocalization.getStorageMain.client_name}
                                    defaultValue=""
                                    required={controllerDocumentCreate.getValidationForm.client_name.required}
                                    onChange={(event) => {
                                        if (controllerDocumentCreate.getValidationForm) {
                                            HelperSrc.checkRegex(
                                                event.target,
                                                event.target.value,
                                                controllerDocumentCreate.getValidationForm.client_name.regex_pattern,
                                                controllerDocumentCreate.getValidationForm.client_name.error_msg
                                            );
                                        }
                                    }}
                                />
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <MuiFormControl className="field_container">
                                <MuiAutocomplete
                                    blurOnSelect
                                    options={(() => {
                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                        for (const optionData of Object.values(controllerDocumentCreate.getSelectOption.client_industry)) {
                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                            optionList.push(optionDataTyped);
                                        }

                                        return optionList;
                                    })()}
                                    getOptionLabel={(option) => option.display_name}
                                    renderOption={(props, option) => {
                                        if (controllerLocalization.getStorageMain) {
                                            return (
                                                <li {...props} data-at_id={`select_client_industry_${option.value ? option.value : "select"}`}>
                                                    {option.display_name || controllerLocalization.getStorageMain.select}
                                                </li>
                                            );
                                        }
                                    }}
                                    isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                    renderInput={(params) => (
                                        <div>
                                            <MuiTextField
                                                {...params}
                                                variant="outlined"
                                                className="field_value"
                                                data-at_id="input_client_industry"
                                                required={
                                                    controllerDocumentCreate.getValidationForm
                                                        ? controllerDocumentCreate.getValidationForm.client_industry.required
                                                        : false
                                                }
                                                onChange={(event) => {
                                                    if (
                                                        controllerDocumentCreate.getValidationForm &&
                                                        controllerDocumentCreate.getElementClientIndustry
                                                    ) {
                                                        HelperSrc.checkRegex(
                                                            controllerDocumentCreate.getElementClientIndustry,
                                                            event.target.value,
                                                            controllerDocumentCreate.getValidationForm.client_industry.regex_pattern,
                                                            controllerDocumentCreate.getValidationForm.client_industry.error_msg
                                                        );
                                                    }
                                                }}
                                                label={
                                                    controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client_industry : ""
                                                }
                                            />
                                            <input
                                                type="hidden"
                                                className="field_value"
                                                name="client_industry"
                                                defaultValue={controllerDocumentCreate.getElementClientIndustryValue}
                                            />
                                        </div>
                                    )}
                                    onChange={(_, option) => {
                                        if (option && controllerDocumentCreate.setElementClientIndustryValue) {
                                            controllerDocumentCreate.setElementClientIndustryValue(option.value as string);
                                        }
                                    }}
                                />
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <MuiFormControl className="field_container">
                                <MuiTextField
                                    variant="outlined"
                                    className="field_value"
                                    data-at_id="input_project_name"
                                    name="project_name"
                                    label={controllerLocalization.getStorageMain.project_name}
                                    defaultValue=""
                                    required={controllerDocumentCreate.getValidationForm.project_name.required}
                                    onChange={(event) => {
                                        if (controllerDocumentCreate.getValidationForm) {
                                            HelperSrc.checkRegex(
                                                event.target,
                                                event.target.value,
                                                controllerDocumentCreate.getValidationForm.project_name.regex_pattern,
                                                controllerDocumentCreate.getValidationForm.project_name.error_msg
                                            );
                                        }
                                    }}
                                />
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <MuiFormControl className="field_container">
                                <ViewDatepicker
                                    variant="outlined"
                                    className="field_value"
                                    fieldMode="datepicker_year"
                                    id="input_document_create_reporting_year"
                                    data-at_id="input_reporting_year"
                                    name="reporting_year"
                                    label={controllerLocalization.getStorageMain.reporting_year}
                                    defaultValue=""
                                    required={controllerDocumentCreate.getValidationForm.reporting_year.required}
                                    onConfirm={(value) => {
                                        if (controllerDocumentCreate.getValidationForm && controllerDocumentCreate.getElementReportingYear) {
                                            HelperSrc.checkRegex(
                                                controllerDocumentCreate.getElementReportingYear,
                                                value,
                                                controllerDocumentCreate.getValidationForm.reporting_year.regex_pattern,
                                                controllerDocumentCreate.getValidationForm.reporting_year.error_msg
                                            );
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (controllerDocumentCreate.getValidationForm) {
                                            HelperSrc.checkRegex(
                                                event.target,
                                                event.target.value,
                                                controllerDocumentCreate.getValidationForm.reporting_year.regex_pattern,
                                                controllerDocumentCreate.getValidationForm.reporting_year.error_msg
                                            );
                                        }
                                    }}
                                />
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <MuiFormControl className="field_container">
                                <MuiRadioGroup>
                                    <p className="section_title">
                                        {controllerLocalization.getStorageMain.template_type}
                                        {controllerDocumentCreate.getValidationForm.template_type.required ? "* " : ""}:
                                    </p>
                                    <div>
                                        <MuiRadio
                                            className="field_value"
                                            data-at_id="radio_template_type_ja_jp"
                                            name="template_type"
                                            value="tnmm_ja_jp"
                                            required={controllerDocumentCreate.getValidationForm.template_type.required}
                                            onChange={(event) => {
                                                if (controllerDocumentCreate.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerDocumentCreate.getValidationForm.template_type.regex_pattern,
                                                        controllerDocumentCreate.getValidationForm.template_type.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <span>{controllerLocalization.getStorageMain.local_file_tnmm_ja_jp}</span>
                                    </div>
                                    <div>
                                        <MuiRadio
                                            className="field_value"
                                            data-at_id="radio_template_type_en_us"
                                            name="template_type"
                                            value="tnmm_en_us"
                                            required={controllerDocumentCreate.getValidationForm.template_type.required}
                                            onChange={(event) => {
                                                if (controllerDocumentCreate.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerDocumentCreate.getValidationForm.template_type.regex_pattern,
                                                        controllerDocumentCreate.getValidationForm.template_type.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <span>{controllerLocalization.getStorageMain.local_file_tnmm_en_us}</span>
                                    </div>
                                    <div>
                                        <MuiRadio
                                            className="field_value"
                                            data-at_id="radio_template_type_apa_ja_jp"
                                            name="template_type"
                                            value="apa_ja_jp"
                                            required={controllerDocumentCreate.getValidationForm.template_type.required}
                                            onChange={(event) => {
                                                if (controllerDocumentCreate.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerDocumentCreate.getValidationForm.template_type.regex_pattern,
                                                        controllerDocumentCreate.getValidationForm.template_type.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <span>{controllerLocalization.getStorageMain.file_apa_ja_jp}</span>
                                    </div>
                                </MuiRadioGroup>
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <MuiFormControl className="field_container">
                                <p className="section_title">{controllerLocalization.getStorageMain.ethical_divider}:</p>
                                <MuiCheckbox
                                    className="field_value"
                                    data-at_id="checkbox_ethical_divider"
                                    name="ethical_divider"
                                    defaultValue=""
                                    required={controllerDocumentCreate.getValidationForm.ethical_divider.required}
                                    onChange={(event) => {
                                        if (controllerDocumentCreate.getValidationForm) {
                                            HelperSrc.checkRegex(
                                                event.target,
                                                event.target.value,
                                                controllerDocumentCreate.getValidationForm.ethical_divider.regex_pattern,
                                                controllerDocumentCreate.getValidationForm.ethical_divider.error_msg
                                            );
                                        }
                                    }}
                                />
                                <span>
                                    {controllerDocumentCreate.getValidationForm.ethical_divider.required ? "* " : ""}
                                    {controllerLocalization.getStorageMain.ed_not_set}
                                </span>
                                <p>{controllerLocalization.getStorageMain.reference_ed}</p>
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <div className="download_template_wrapper">
                                <div className="download_template_container">
                                    <p>{controllerLocalization.getStorageMain.dcdt}</p>
                                    <MuiButton
                                        className="button_primary"
                                        data-at_id="button_dcdt"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.conflic_decision_tree_doc
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.japanese}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="content">
                            <p className="section_title">
                                {controllerLocalization.getStorageMain.input_template}
                                {controllerDocumentCreate.getValidationForm.template_file.required ? "* " : ""}:
                            </p>
                            <MuiButton
                                className="button_primary button_input_upload_fake"
                                data-at_id="button_template_file"
                                onClick={() => {
                                    controllerDocumentCreate.clickUpload(".upload_template");
                                }}
                            >
                                {controllerLocalization.getStorageMain.choose_file}
                            </MuiButton>
                            {controllerDocumentCreate.getFilenameList.template_file}
                            <MuiFormControl className="field_container input_template">
                                <div className="field_value">
                                    <input
                                        className="input_upload upload_template"
                                        data-at_id="input_template_file"
                                        name="template_file"
                                        type="file"
                                        multiple={false}
                                        required={controllerDocumentCreate.getValidationForm.template_file.required}
                                        onChange={(event) => {
                                            if (controllerDocumentCreate.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerDocumentCreate.getValidationForm.template_file.regex_pattern,
                                                    controllerDocumentCreate.getValidationForm.template_file.error_msg
                                                );
                                            }
                                            controllerDocumentCreate.returnFilename("template_file", event.target.files);
                                        }}
                                    />
                                </div>
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <div className="download_template_wrapper">
                                <div className="download_template_container">
                                    <p>{controllerLocalization.getStorageMain.download_tnmm}</p>
                                    <MuiButton
                                        className="button_primary"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.tnmm_template_excel_ja
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.japanese}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                    <MuiButton
                                        className="button_primary"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.tnmm_template_excel_en
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.english}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                </div>
                                <div className="download_template_container">
                                    <p>{controllerLocalization.getStorageMain.download_apa}</p>
                                    <MuiButton
                                        className="button_primary"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.apa_template_excel
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.japanese}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                </div>
                            </div>
                            <p className="section_title">{controllerLocalization.getStorageMain.itfea}</p>
                            <MuiButton
                                className="button_primary button_input_upload_fake"
                                data-at_id="button_ea_template_file"
                                onClick={() => {
                                    controllerDocumentCreate.clickUpload(".upload_template_ea");
                                }}
                            >
                                {controllerLocalization.getStorageMain.choose_file}
                            </MuiButton>
                            {controllerDocumentCreate.getFilenameList.ea_template_file}
                            <MuiFormControl className="field_container">
                                <div className="field_value">
                                    <input
                                        className="input_upload upload_template_ea"
                                        data-at_id="input_ea_template_file"
                                        name="ea_template_file"
                                        type="file"
                                        multiple={false}
                                        required={controllerDocumentCreate.getValidationForm.ea_template_file.required}
                                        onChange={(event) => {
                                            controllerDocumentCreate.returnFilename("ea_template_file", event.target.files);
                                        }}
                                    />
                                </div>
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <div className="download_template_wrapper">
                                <div className="download_template_container">
                                    <p>{controllerLocalization.getStorageMain.download_ea_3y}</p>
                                    <MuiButton
                                        className="button_primary"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.bm_template_3y_excel_ja
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.japanese}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                    <MuiButton
                                        className="button_primary"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.bm_template_3y_excel_en
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.english}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                </div>
                                <div className="download_template_container">
                                    <p>{controllerLocalization.getStorageMain.download_ea_5y}</p>
                                    <MuiButton
                                        className="button_primary"
                                        disabled={controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate}
                                        onClick={() => {
                                            if (controllerDocumentCreate.getStorageSetting) {
                                                controllerDocumentCreate.clickDownloadStaticTemplate(
                                                    controllerDocumentCreate.getStorageSetting.bm_template_5y_excel_ja
                                                );
                                            }
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerDocumentCreate.getApiLoadingList.downloadStaticTemplate) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.japanese}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                </div>
                            </div>
                            <p className="section_title">{controllerLocalization.getStorageMain.figure_captial_sturcture}</p>
                            <MuiButton
                                className="button_primary button_input_upload_fake"
                                data-at_id="button_cs_image"
                                onClick={() => {
                                    controllerDocumentCreate.clickUpload(".upload_cs_image");
                                }}
                            >
                                {controllerLocalization.getStorageMain.choose_file}
                            </MuiButton>
                            {controllerDocumentCreate.getFilenameList.cs_image}
                            <MuiFormControl className="field_container">
                                <div className="field_value">
                                    <input
                                        className="input_upload upload_cs_image"
                                        data-at_id="input_cs_image"
                                        name="cs_image"
                                        type="file"
                                        multiple={false}
                                        required={controllerDocumentCreate.getValidationForm.cs_image.required}
                                        onChange={(event) => {
                                            controllerDocumentCreate.returnFilename("cs_image", event.target.files);
                                        }}
                                    />
                                </div>
                                <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                            </MuiFormControl>
                            <p className="section_title">{controllerLocalization.getStorageMain.figure_organization_sturcture}</p>
                            <div>
                                <p className="section_title_sub">1. {controllerLocalization.getStorageMain.compnay_group_1}:</p>
                                <MuiButton
                                    className="button_primary button_input_upload_fake"
                                    data-at_id="button_company_1_image"
                                    onClick={() => {
                                        controllerDocumentCreate.clickUpload(".upload_company_1_image");
                                    }}
                                >
                                    {controllerLocalization.getStorageMain.choose_file}
                                </MuiButton>
                                {controllerDocumentCreate.getFilenameList.company_1_image}
                                <MuiFormControl className="field_container">
                                    <div className="field_value">
                                        <input
                                            className="input_upload upload_company_1_image"
                                            data-at_id="input_company_1_image"
                                            name="company_1_image"
                                            type="file"
                                            multiple={false}
                                            required={controllerDocumentCreate.getValidationForm.company_1_image.required}
                                            onChange={(event) => {
                                                controllerDocumentCreate.returnFilename("company_1_image", event.target.files);
                                            }}
                                        />
                                    </div>
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </MuiFormControl>
                                <p className="section_title_sub">2. {controllerLocalization.getStorageMain.international_company_1}:</p>
                                <MuiButton
                                    className="button_primary button_input_upload_fake"
                                    data-at_id="button_company_2_image"
                                    onClick={() => {
                                        controllerDocumentCreate.clickUpload(".upload_company_2_image");
                                    }}
                                >
                                    {controllerLocalization.getStorageMain.choose_file}
                                </MuiButton>
                                {controllerDocumentCreate.getFilenameList.company_2_image}
                                <MuiFormControl className="field_container">
                                    <div className="field_value">
                                        <input
                                            className="input_upload upload_company_2_image"
                                            data-at_id="input_company_2_image"
                                            name="company_2_image"
                                            type="file"
                                            multiple={false}
                                            required={controllerDocumentCreate.getValidationForm.company_2_image.required}
                                            onChange={(event) => {
                                                controllerDocumentCreate.returnFilename("company_2_image", event.target.files);
                                            }}
                                        />
                                    </div>
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </MuiFormControl>
                            </div>
                        </div>
                    </div>
                    <div className="bottom">
                        <MuiFormControl className="button_container">
                            <MuiButton
                                className="button_primary"
                                data-at_id="button_back"
                                disabled={controllerDocumentCreate.getApiLoadingList.create}
                                onClick={() => {
                                    controllerDocumentCreate.clickBack();
                                }}
                            >
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (controllerDocumentCreate.getApiLoadingList.create) {
                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                    } else {
                                        html.push(<>{controllerLocalization.getStorageMain.back}</>);
                                    }

                                    return html;
                                })()}
                            </MuiButton>
                            <MuiButton
                                className="button_primary"
                                data-at_id="button_save"
                                disabled={controllerDocumentCreate.getApiLoadingList.create}
                                onClick={(event) => {
                                    controllerDocumentCreate.clickSave(event);
                                }}
                            >
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (controllerDocumentCreate.getApiLoadingList.create) {
                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                    } else {
                                        html.push(<>{controllerLocalization.getStorageMain.save}</>);
                                    }

                                    return html;
                                })()}
                            </MuiButton>
                        </MuiFormControl>
                    </div>
                </form>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageDocumentCreate;
